import { apiGet, apiPost } from './api';

export type EmailTestParam = {
  key: string;
  label: string;
  type: 'string' | 'number' | 'boolean' | 'json';
  default?: string | number | boolean;
};

export type EmailTestTemplate = {
  id: string;
  name: string;
  category: string;
  description: string;
  params: EmailTestParam[];
};

export type EmailPreviewResult = {
  templateId: string;
  subject: string;
  language: string;
  html: string;
};

export type EmailSendTestResult = {
  templateId: string;
  recipient: string;
  subject: string;
  language: string;
  sentAt: string;
};

export async function listEmailTemplates() {
  return apiGet<{
    success: boolean;
    data: { templates: EmailTestTemplate[]; categories: string[]; total: number };
  }>('/api/v1/admin/emails/templates');
}

export async function getEmailTemplate(templateId: string, language: 'en' | 'fr' = 'fr') {
  return apiGet<{
    success: boolean;
    data: EmailTestTemplate & { sampleData: Record<string, unknown> };
  }>(`/api/v1/admin/emails/templates/${templateId}?language=${language}`);
}

export async function previewEmail(payload: {
  templateId: string;
  language: 'en' | 'fr';
  params: Record<string, unknown>;
}) {
  return apiPost<{ success: boolean; data: EmailPreviewResult }>('/api/v1/admin/emails/preview', payload);
}

export async function sendTestEmail(payload: {
  templateId: string;
  recipient: string;
  language: 'en' | 'fr';
  params: Record<string, unknown>;
}) {
  return apiPost<{ success: boolean; data: EmailSendTestResult }>('/api/v1/admin/emails/send-test', payload);
}
